import { render, staticRenderFns } from "./CompaniesTab.vue?vue&type=template&id=1d3d35c4"
import script from "./CompaniesTab.vue?vue&type=script&lang=ts"
export * from "./CompaniesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports